import RachelMarkdown from '../../../RachelMarkdown/RachelMarkdown';

interface RachelReasoningPartProps {
  text: string;
}

const RachelReasoningPart = ({ text }: RachelReasoningPartProps) => {
  if (!text?.trim()) {
    return null;
  }

  return <RachelMarkdown>{text}</RachelMarkdown>;
};

export default RachelReasoningPart;
